import { WISHLIST_DATA_COOKIE_KEY, WISHLIST_GUEST_USER_COOKIE_KEY } from '../constants';
import Cookies from 'js-cookie';

export const getWishlistItem = (wishlistSkus: string[], sku: string) => {
  const wishedItem = wishlistSkus.find((item) => item === sku);

  return {
    wishedItem,
    isWished: Boolean(wishedItem),
  };
};

export const getWishListCustomerKeyCookie = () => {
  const wishlistGuestKey = Cookies.get(WISHLIST_GUEST_USER_COOKIE_KEY);
  return { wishlistGuestKey };
};

/**
 * Only for sync data with wordpress, not for NextJS
 * @param wishlistSkus
 */
export const setWishlistSku = (wishlistSkus: string[]) => {
  if (wishlistSkus.length === 0) {
    Cookies.remove(WISHLIST_DATA_COOKIE_KEY);
    return;
  }
  const joinedWishlistSkus = wishlistSkus.join('|');
  Cookies.set(WISHLIST_DATA_COOKIE_KEY, joinedWishlistSkus);
};
